module.exports = __webpack_public_path__ + "img/bulk-processing.320a0ab5.svg";